export function getDefaultLanguage(browserLanguage?: string, savedLanguage?: string, availableLanguages: string[] = []) {
  if (savedLanguage) {
    return savedLanguage
  }

  if (browserLanguage) {
    const prefix = browserLanguage.split("-")[0].toLocaleLowerCase()
    const matchingLanguage = availableLanguages.find(lang => lang.startsWith(prefix))

    return matchingLanguage ?? "en-US"
  }

  return "en-US"
}
